var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectMatchState, selectShowShooters, setMatchState, toggleShowShooters, } from "../../../store/match";
import { shootoutChallenge } from "../../../api";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { ModalNew } from "../../atoms/Modal/Modal";
import { ModalWrapperNew } from "../../atoms/ModalWrapper/ModalWrapper";
import { Delimiter } from "../../atoms/Delimiter";
const commonStyle = {
    width: "30px",
    height: "44px",
    display: "flex",
    marginRight: "6px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    transition: "0.3s",
    fontSize: "20px",
    color: "#fff",
};
const Wrapper = styled(ModalWrapperNew) `
  padding: 32px 40px 40px;
  max-width: calc(100vw - 150px);
`;
const SelectWrapper = styled(ModalWrapperNew) `
  align-items: flex-start;
  padding: 24px;
  min-width: 240px;
`;
const Title = styled.div `
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
`;
const ShootingDescription = styled.div `
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  width: 330px;

  span {
    font-weight: 600;
    color: #ffd643;
  }
`;
const FlexContainer = styled.div `
  display: flex;
  align-items: center;
`;
const ShootingPlayersContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
`;
const PlayerContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 114px;
  cursor: pointer;
  overflow: visible;
`;
const PlayerImgContainer = styled.div `
  position: relative;
  width: 94px;
  height: 94px;
  padding: 4px;
  border: 2px solid #517573;
  border-radius: 50%;
`;
const PlayerImg = styled.img `
  width: 82px;
  height: 82px;
  filter: drop-shadow(0px 0px 4px rgba(34, 43, 38, 0.5));
  user-select: none;
  border-radius: 50%;
  object-fit: cover;
`;
const PlayerNick = styled.div `
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  text-shadow: 0px 5px 10px rgba(34, 43, 38, 0.6);
`;
const VersusText = styled.div `
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #2ab2ff;
  margin-top: ${({ nextRow }) => (nextRow ? "109px" : "31px")};
  ${({ margin }) => margin &&
    `
    margin: ${margin};
  `}
`;
const ShootingContainerImage = styled.img `
  width: 76px;
  height: 63px;
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
`;
const PlayerSmallContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const PlayerSmallImg = styled.img `
  width: 40px;
  height: 40px;
  border-radius: 50%;
  user-select: none;
  object-fit: cover;
`;
const PlayerSmallNick = styled.div `
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
`;
const ShootingPlayerAction = styled.div `
  font-size: 12px;
  line-height: 16px;
  color: #2ab2ff;
`;
const ShootingRange = styled.div `
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(7px);
  border-radius: 51px;
  width: 30px;
  height: 44px;
  margin-left: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 44px;
  color: #ffffff;
  text-align: center;
  transition: 0.3s;

  ${({ active }) => active &&
    `
    font-weight: 600;
    background: #2AB2FF;
  `}

  &:first-child {
    margin-left: 0;
  }
`;
export function ShootingPlayer() {
    var _a, _b, _c;
    const matchState = useAppSelector(selectMatchState);
    const showShooters = useAppSelector(selectShowShooters);
    const [value, setValue] = useState(0);
    const dispatch = useAppDispatch();
    const { errorHandler } = useErrorHandler();
    const theme = useTheme();
    const activeStyle = {
        borderWidth: "2px",
        borderColor: theme.palette.primary.main,
        borderStyle: "solid",
    };
    const players = (((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state.shootout) === null || _a === void 0 ? void 0 : _a.players) || []).map((player) => (matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === player.id)) || null);
    const player = () => (matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === (matchState === null || matchState === void 0 ? void 0 : matchState.state.currentPlayer))) ||
        null;
    const range = ((_b = matchState === null || matchState === void 0 ? void 0 : matchState.state.shootout) === null || _b === void 0 ? void 0 : _b.range) || [];
    const shootoutId = () => { var _a; return (_a = matchState === null || matchState === void 0 ? void 0 : matchState.state.shootout) === null || _a === void 0 ? void 0 : _a.id; };
    useEffect(() => {
        setValue((range === null || range === void 0 ? void 0 : range[0]) || 0);
    }, [matchState]);
    const onButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        var _d;
        try {
            const result = yield shootoutChallenge(shootoutId(), value);
            // console.log('ShootingPlayer onButtonClick', result)
            if (!((_d = result.state) === null || _d === void 0 ? void 0 : _d.shootout))
                dispatch(toggleShowShooters());
            dispatch(setMatchState(result));
        }
        catch (e) {
            errorHandler(e);
            console.error("ShootingPlayer onButtonClick error", e.response);
        }
    });
    return (_jsx(ModalNew, Object.assign({ lightShadow: true, onClose: () => null }, { children: showShooters ? (_jsxs(Wrapper, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u041D\u0430\u043C\u0435\u0447\u0430\u0435\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u0441\u0442\u0440\u0435\u043B\u043A\u0430" })), _jsx(Delimiter, { top: "14px" }), _jsx(Typography, Object.assign({ variant: "body1" }, { children: "\u0423 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043E\u0434\u0438\u043D\u0430\u043A\u043E\u0432\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0433\u043E\u043B\u043E\u0441\u043E\u0432. \u041A\u0442\u043E \u0431\u0443\u0434\u0435\u0442 \u0443\u0431\u0438\u0442 - \u0440\u0435\u0448\u0438\u0442 \u043F\u0435\u0440\u0435\u0441\u0442\u0440\u0435\u043B\u043A\u0430" })), _jsx(Delimiter, { top: "26px" }), _jsx(ShootingPlayersContainer, { children: players.map((p, index) => (_jsxs(FlexContainer, { children: [index > 0 && index !== 5 ? (_jsxs(FlexContainer, { children: [_jsx(Delimiter, { right: "10px" }), _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: "\u043F\u0440\u043E\u0442\u0438\u0432" })), _jsx(Delimiter, { right: "10px" })] })) : (""), _jsxs(PlayerContainer, { children: [index >= 5 ? (_jsxs(FlexContainer, { children: [_jsx(Delimiter, { right: "10px" }), _jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: "\u043F\u0440\u043E\u0442\u0438\u0432" })), _jsx(Delimiter, { right: "10px" })] })) : (""), _jsx(Typography, Object.assign({ sx: { textAlign: "center" }, variant: "h4" }, { children: p.player.gameName || p.player.realName }))] })] }, p.id))) }), _jsx(Delimiter, { top: "32px" }), _jsx(Button, Object.assign({ variant: "contained", onClick: () => dispatch(toggleShowShooters()) }, { children: "\u041D\u0430\u0447\u0430\u0442\u044C \u043F\u0435\u0440\u0435\u0441\u0442\u0440\u0435\u043B\u043A\u0443" }))] })) : (_jsxs(SelectWrapper, { children: [_jsxs(PlayerSmallContainer, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: ((_c = player()) === null || _c === void 0 ? void 0 : _c.player.gameName) || "" })), _jsx(Typography, Object.assign({ variant: "body1" }, { children: "\u0414\u0435\u043B\u0430\u0435\u0442 \u0432\u044B\u0441\u0442\u0440\u0435\u043B" }))] }), _jsx(Delimiter, { top: "14px" }), _jsx(FlexContainer, { children: range.map((n) => (_jsx(Paper, Object.assign({ onClick: () => setValue(n), sx: n === value ? Object.assign(Object.assign({}, commonStyle), activeStyle) : commonStyle }, { children: n == value ? n + "*" : n }), n))) }), _jsx(Delimiter, { top: "20px" }), _jsx(Button, Object.assign({ variant: "contained", onClick: onButtonClick }, { children: "\u0412\u044B\u0441\u0442\u0440\u0435\u043B" }))] })) })));
}
